import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';

@Component({
  selector: 'app-payment-status-modal',
  templateUrl: './payment-status-modal.component.html',
  styleUrls: ['./payment-status-modal.component.css']
})
export class PaymentStatusModalComponent implements OnInit {

  paymentDetails:any;
  isLoading:boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PaymentStatusModalComponent>,
    private router: Router,
    private walletService: WalletinfoService,
    private toastrService: CustomControlsService,
    private whitelabelService: WhiteLabelService
  ) { }

  ngOnInit(): void {
    if(this.data.mode !== 'wallet'){
      console.log(this.data);
      this.getOrderStatus(this.data.transactionId);
    }else if(this.data.mode === 'wallet'){
      this.paymentDetails = this.data;
      console.log(this.paymentDetails);
    }
  }

  getOrderStatus(orderId:any){
    this.isLoading = true;
    this.walletService.getOrderStatus(orderId).subscribe((result)=>{
      console.log(result);
      this.paymentDetails = result;
      this.isLoading = false;
    },(error)=>{
      this.isLoading = false;
      this.showToast('warning', 'Something went wrong! Please try after sometime.')
    })
  }

  showToast(type:any, message:any) {
    this.toastrService.showNotification(
      type,
      '',
      message,
      5000
    );
  }

  openDetails(){
    if(this.data.detailsRoute === 'channel'){
      const route = this.whitelabelService.getPrefixedRoute('settings');
      this.router.navigate([route]);
    }else if(this.data.detailsRoute === 'wallet'){
      const route = this.whitelabelService.getPrefixedRoute('wallet');
      this.router.navigate([route]);
    }
    this.dialogRef.close(true);
  }

  openVideoDetails(){
    const route = this.whitelabelService.getPrefixedRoute('movies', this.data?.vidLibId, this.data?.vidLibId);
    this.router.navigate([route]);
    this.dialogRef.close(true);
  }

  closeModal(){
    this.dialogRef.close(false);
  }
}